<tm-info-alert
  (afterConfirm)="afterConfirm.emit()"
  (afterCancel)="afterCancel.emit()">
</tm-info-alert>
